export default {
    confirmLabel: '确定'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/input-item/locale/zh_CN.js
// module id = 228
// module chunks = 0